import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import TextInfo from '@bit/gerenciatd.unifiedcomponents.text-info';
import Button from '@bit/gerenciatd.unifiedcomponents.button';
import Image from '@bit/gerenciatd.unifiedcomponents.image';
import CustomLink from '@bit/gerenciatd.unifiedcomponents.custom-link';
import ModalAtencionEmp from '@bit/gerenciatd.unifiedcomponents.modal-atencion-emp';
import { generateBgAndProperties, requestCampaignToScxBackend } from '../../utils/common.utils';
import './BarraDestacada.scss';

export const COMPONENT_NAME = 'barra-destacada';

export const giveRandomNumber = (min, max) => Math.floor(Math.random() * max) + min;
export const generateComponentId = (componentName, aditionalId = '', id = giveRandomNumber(1, 999)) => {
  return `${componentName}-${id}${aditionalId ? `-${aditionalId}` : ''}`;
};
export const barraDestacadaId = generateComponentId(COMPONENT_NAME, 'distributiva');

const BarraDestacada = (props) => {
  const {
    components, visible, modalAtencionConfig, Modal, SvgIconLoader,
  } = props;

  generateBgAndProperties(barraDestacadaId, components);
  if (!visible) {
    return null;
  }

  const setUpModalProps = () => {
    Modal.setModalProps({
      contentPosition: 'right--center',
      opacityLayoutColor: 'black05',
      inSceneEffect: 'faseInLeft',
      outSceneEffect: 'fadeOutRight',
      closeByClickingOutside: true,
      scrollAllowed: false,
    });
  };

  const handleNewModal = (item) => {
    setUpModalProps();
    Modal.setContent(
      <ModalAtencionEmp
        Modal={Modal}
        taggingInfo={{
          ...item.taggingInfo,
        }}
        SvgIconLoader={SvgIconLoader}
        campaign={item.campaign}
        product={item.product}
        tabsOptions={{ ...modalAtencionConfig, tabOptionPreChecked: item.option }}
      />,
    );
    return Modal.show();
  };


  return (
    <Fragment>
      {components && (components['Button-1'] || components['Button-solicita']) && (
        <section className="BarraDestacada" id={barraDestacadaId}>
          <div className="BarraDestacada__container container">
            <div className="BarraDestacada__wrapper">
              {components && components['Imagen-1'] && (
                <Image
                  {...components['Imagen-1']}
                  className="BarraDestacada__image"
                />
              )}
              {components && components['TextInfo-1'] && (
                <TextInfo
                  {...components['TextInfo-1']}
                  className="BarraDestacada__wrapper_text"
                />
              )}
              { components && components['Button-1'] && (
                <Button
                  {...components['Button-1']}
                  link={`${components['Button-1'].link}`}
                  className="BarraDestacada__button"
                  taggingInfo={{
                    componentName: COMPONENT_NAME,
                    componentContent: 'Black-Friday',
                    componentProduct: '',
                    componentVariation: 'all',
                  }}
                />
              )}
              {components && components['Button-solicita'] && (
                <Button
                  {...components['Button-solicita']}
                  onClick={() => { handleNewModal(components['Button-solicita']) }}
                  className="BarraDestacada__button"
                  taggingInfo={{
                    componentName: COMPONENT_NAME,
                    componentContent: 'Black-Friday',
                    componentProduct: '',
                    componentVariation: 'all',
                  }}
                />
              )}
              {components && components['Button-solicita'] && (
                <CustomLink
                  onClick={() => { handleNewModal(components['Button-solicita']) }}
                  target="_blank"
                  taggingInfo={{
                    ...components['Button-solicita'].taggingInfo,
                    componentName: COMPONENT_NAME,
                    componentVariation: 'all',
                  }}
                  isBlockElement
                />
              )}
              {components && components['Button-1'] && (
                <CustomLink
                  link={components['Button-1'].link}
                  target="_blank"
                  taggingInfo={{
                    ...components['Button-1'].taggingInfo,
                    componentName: COMPONENT_NAME,
                    componentVariation: 'all',
                  }}
                  isBlockElement
                />
              )}
            </div>
          </div>
        </section>
      )}
    </Fragment>
  )
}

BarraDestacada.propTypes = {
  components: PropTypes.array.isRequired,
  visible: PropTypes.bool,
};

BarraDestacada.defaultProps = {
  visible: true,
};

export default BarraDestacada;
